import translate from '@i18n'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileCSS } from '@measures/responsive'
import { FunctionComponent, Ref } from 'react'
import MainText from '@components/Video/Trailer/MainText'
import PrimaryCTAButton from '@components/Buttons/PrimaryCTAButton'

const StyledOverlayWrapper = styled.div`
  ${({
    theme: {
      animation: {
        transition: { fast: animationTransitionFast },
      },
      colors: { staticBlack },
    },
  }) => {
    return css`
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 8;
      width: 100%;
      height: 100%;
      background-color: ${staticBlack};
      @keyframes fadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
      animation: ${animationTransitionFast} fadeIn ease-in-out;
    `
  }}
`
const StyledOverlayContainer = styled.div`
  ${({
    theme: {
      spacing: { spacing24 },
      colors: { staticNeutral100, staticBlack },
    },
  }) => {
    return css`
      max-width: 500px;
      padding: 0 ${spacing24};
      color: ${staticNeutral100};
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: ${staticBlack};
      ${mobileCSS(css`
        max-width: unset;
        width: 100%;
      `)}
    `
  }}
`

const StyledTitle = styled.h1`
  ${({
    theme: {
      typography: {
        headings: {
          small: { bundledCSS: headingSmallCSS },
          xsmall: { bundledCSS: headingXSmallCSS },
        },
      },
    },
  }) => {
    return css`
      ${headingXSmallCSS};
      width: 100%;
      text-align: center;
      ${desktopCSS(css`
        ${headingSmallCSS};
      `)}
      margin: 0;
    `
  }}
`

interface TrailerVideoOverlayComponentProps {
  onScroll: () => void
  onCloseClick: () => void
  ref?: Ref<HTMLDivElement>
}

const TrailerVideoOverlayComponent: FunctionComponent<
  TrailerVideoOverlayComponentProps
> = ({ onScroll, ref = null }) => (
  <StyledOverlayWrapper ref={ref}>
    <StyledOverlayContainer>
      <StyledTitle>{translate('video.trailer.blickPlus.title')}</StyledTitle>
      <MainText>{translate(`video.trailer.blickPlus.mainText`)}</MainText>
      <PrimaryCTAButton size="large" onClick={onScroll}>
        {translate('video.blickPlus.buttonLabel')}
      </PrimaryCTAButton>
    </StyledOverlayContainer>
  </StyledOverlayWrapper>
)

export default TrailerVideoOverlayComponent
